"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var get_1 = tslib_1.__importDefault(require("lodash/get"));
var contests_core_1 = require("@biw/contests-core");
var contests_constants_1 = require("@biw/contests-constants");
function getProgressProps(state, program) {
    var programViewId = program.programViewId;
    var progressModel = contests_core_1.progress.selectors.getProgress(state, programViewId) || {};
    var statusTreatment = progressModel.progressStatusTreatment;
    var goalProgress = get_1.default(progressModel, 'goalProgress') || {};
    return {
        tileType: 'progress',
        progressPercent: goalProgress.progressPercentage || 0,
        onTrackPct: goalProgress.onTrackPercentage || 0,
        currentGoalValue: goalProgress.currentGoalValue || 0,
        dateThroughPercentage: get_1.default(progressModel, 'throughProgram.percentage') * 100,
        goalAchieveAmount: get_1.default(progressModel, 'selectedGoal.goalAchieveAmount'),
        statusTreatment: statusTreatment,
        daysLeft: program.daysToProgramEndDate,
        calendarLabel: 'progress.daysToEarnLabel',
        footerMessageCode: program.programHasEnded ?
            contests_constants_1.KEY_CODES.checkingResults :
            statusTreatment.label,
        buttonTextCode: contests_constants_1.KEY_CODES.viewDetails,
        programCalculationType: progressModel.programCalculationType,
        isReduction: progressModel.isReduction,
        isStandard: progressModel.isStandard,
        isAverage: progressModel.isAverage,
        goalLabel: get_1.default(progressModel, 'goalOverview.goalLabelProps')
    };
}
exports.default = getProgressProps;
//# sourceMappingURL=progress-props.js.map